<template>
  <div>
    <div :class="`menubuilder__logo ${logo.data == '' && 'menubuilder__logo--empty'}`">
      <span v-if="logo.data === ''">
        Your logo <br /> goes here
      </span>
      <div v-else class="menubuilder__logo menubuilder__logo--full">
        <img :src="logo.data" alt="">
        <span @click="clearLogo">&times;</span>
      </div>

    </div>
    <input type="file" accept=".png, .jpg, .jpeg" name="logo" id="logo" @change="updatePreview($event)" class="menubuilder__logoupload">
    <button class="menubuilder__button" @click="uploadFile">
      Upload a logo
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: this.$store.state.logo
    }
  },
  methods: {
    uploadFile() {
      jQuery(".menubuilder__logoupload").click()
    },
    clearLogo() {
      this.$store.setLogo(undefined)

      jQuery(".menubuilder__logoupload").val("")
    },
    setLogo(logoData) {
      this.$store.setLogo(logoData)
    },
    updatePreview(e) {
      const input = e.target;
      const _URL = window.URL || window.webkitURL;
      if (input.files && input.files[0]) {
        const reader = new FileReader()
        var that = this
        reader.onload = function(e) {
          that.$store.setLogo(e.target.result)
        }

        reader.readAsDataURL(input.files[0]); // convert to base64 string

        const img = new Image();
        var objectUrl = _URL.createObjectURL(input.files[0]);
        img.onload = function () {
          that.$store.setLogoDimensions(this.height, this.width);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;

      }


    }
  }
}
</script>

<style lang="sass">
@import "../../../../styles/partials/variables"

#menubuilder
  .menubuilder
    &__logoupload
      position: absolute
      margin-left: -999999px

    &__logo
      width: 170px
      height: 170px
      border-radius: 50%
      margin: 0 auto
      display: flex
      flex-flow: row wrap
      justify-content: center
      align-items: center
      position: relative

      &:after
        transition: all 0.3s ease-out

      &:hover:after
        content: ""

      &--full
        width: 300px

        span
          position: absolute
          top: 0
          bottom: 0
          left: 0
          right: 0
          display: flex
          justify-content: center
          align-items: center
          opacity: 0
          transition: all 0.3s ease-out
          color: $color-black!important
          cursor: pointer

          &:hover
            opacity: 1
            background: rgba($color-white, 0.5)

      &--empty
        @include dotted-border

      span
        color: $color-grey
        font-size: 22px
        text-align: center
        line-height: 28px

    &__button
      margin: 0 auto
      display: block
      border: none !important
      margin-top: 20px
      background-color: $color-green
      outline: none

      &:hover
        background-color: $color-green-light

</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MenuBuilder/LogoUpload.vue